import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-contact-address-page",
  templateUrl: "./ContactAddressPage.html"
})
export class ContactAddressPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

  public get availableLanguages() {
    return this.appController.availableLanguages;
  }

  public get availableCountries() {
    return this.appController.availableCountries;
  }

}
